import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  search() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value.trim()
      const url = this.inputTarget.dataset.url

      if (query.length >= 2) {
        fetch(`${url}?q=${encodeURIComponent(query)}`, {
          headers: {
            "Accept": "text/html",
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-Token": this.csrfToken
          },
          credentials: "same-origin"
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            return response.text()
          })
          .then(html => {
            this.resultsTarget.innerHTML = html
          })
          .catch(error => {
            console.error("Search failed:", error)
          })
      } else {
        this.resultsTarget.innerHTML = ""
      }
    }, 200)
  }
}
